/** Monotonic counter incremented only on forward navigations (not POP). */
let forwardEpoch = 0;
const subscribers = new Set<() => void>();

export function getBulkSelectionForwardNavEpoch(): number {
  return forwardEpoch;
}

export function subscribeBulkSelectionForwardNavEpoch(listener: () => void): () => void {
  subscribers.add(listener);
  return () => {
    subscribers.delete(listener);
  };
}

export function bumpBulkSelectionForwardNavEpoch(): void {
  forwardEpoch++;
  subscribers.forEach((fn) => {
    fn();
  });
}

/** Canonical routing key omitting tab param `vl` (different tabs on the same page → same key). */
export function canonicalPathForBulkSelectionNav(loc: Pick<Location, 'pathname' | 'search'>): string {
  const params = new URLSearchParams(loc.search);
  params.delete('vl');
  const keys = [...new Set([...params.keys()])].toSorted();
  const next = new URLSearchParams();
  for (const key of keys) {
    for (const v of params.getAll(key).toSorted()) {
      next.append(key, v);
    }
  }
  const qs = next.toString();
  return qs ? `${loc.pathname}?${qs}` : loc.pathname;
}
